// extracted by mini-css-extract-plugin
export default {"root":"BarbellSizes_root__NQ7CW","root__item":"BarbellSizes_root__item__rIR26","root__circle":"BarbellSizes_root__circle__LTe+r"};